// Original, plain-language legal copy for the Life With Abba clone.
// NOTE: This is placeholder policy content — review with legal counsel before launch.

export const TERMS = {
  title: "Terms of Service",
  updated: "Last updated: June 2025",
  intro:
    "Welcome to Life With Abba. By downloading, accessing, or using our app and website, you agree to these Terms of Service. Please read them carefully.",
  sections: [
    {
      heading: "Acceptance of Terms",
      body: "By creating an account or using any part of the Life With Abba service, you confirm that you accept these terms and agree to comply with them. If you do not agree, please do not use the service.",
    },
    {
      heading: "Your Account",
      body: "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Please notify us promptly of any unauthorized use.",
    },
    {
      heading: "Your Content",
      body: "The photos, videos, writings, recordings, and other content you create in the app belong to you. Your private posts are intended for your personal, devotional use and are protected with encryption. We do not sell your content.",
    },
    {
      heading: "Subscriptions & Billing",
      body: "Premium and Family plans are billed through your app store account. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period. You may manage or cancel your subscription in your app store settings.",
    },
    {
      heading: "Acceptable Use",
      body: "You agree not to misuse the service, attempt to disrupt it, or use it for any unlawful purpose. We reserve the right to suspend accounts that violate these terms.",
    },
    {
      heading: "Changes to These Terms",
      body: "We may update these terms from time to time. When we do, we will revise the date above and, where appropriate, notify you within the app.",
    },
    {
      heading: "Contact",
      body: "Questions about these terms? Please reach out through our Contact page and we will be glad to help.",
    },
  ],
};

export const PRIVACY = {
  title: "Privacy Policy",
  updated: "Last updated: June 2025",
  intro:
    "Your relationship with Abba is sacred, and so is your privacy. This policy explains what information we collect, how we use it, and the choices you have.",
  sections: [
    {
      heading: "Information We Collect",
      body: "We collect the information you provide when you create an account, such as your name and email address. We also collect basic technical data (like device type and app version) to keep the service running smoothly.",
    },
    {
      heading: "Your Journal Content",
      body: "The content you create in Life With Abba is private to you. It is protected with end-to-end encryption and secure cloud backup. We cannot read your posts, and we never sell them.",
    },
    {
      heading: "How We Use Information",
      body: "We use your information to provide and improve the service, to sync your journal across your devices, to process subscriptions, and to communicate important updates.",
    },
    {
      heading: "Security",
      body: "We use industry-standard safeguards, including encryption, passcode and biometric locks, to protect your information. No system is perfectly secure, but we work hard to keep your data safe.",
    },
    {
      heading: "Your Choices",
      body: "You may access, update, or delete your account information at any time. Deleting your account permanently removes your journal from our servers.",
    },
    {
      heading: "Children's Privacy",
      body: "Life With Abba is not directed to children under 13, and we do not knowingly collect personal information from them.",
    },
    {
      heading: "Contact",
      body: "If you have any questions about this policy or your data, please reach out through our Contact page.",
    },
  ],
};
